<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 8a8 8 0 1 0 7.992-8A8 8 0 0 0 0 8z" style="fill:#ef4f44" fill="currentColor"/><path d="M-2.381 0h5.115v-1.364H-.753v-2.178h2.86v-1.364h-2.86v-1.881h3.366V-8.14h-4.994z" style="fill:#fff" transform="translate(8 12)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-error',
});
</script>
